import gql from 'graphql-tag';

import { ImageFragments } from './fragments/ImageType';
import { UserFragments } from './fragments/UserType';

export const getWaypoint = gql`
  query GetWaypoint($id: ID!) {
    waypoint(id: $id) {
      _id: externalId
      lat
      lng
      name
      description
      symbol
      image(croppingStrategy: CENTER, width: 400, format: WEBP) {
        ...ImageFields
      }
      user {
        nickname
        ...UserId
        ...UserAvatar
      }
    }
  }
  ${UserFragments.id}
  ${UserFragments.avatar}
  ${ImageFragments.imageFields}
`;
